import { Link } from "react-router-dom";

/** Monogramme : un ballon dessiné comme un rond central de parquet, traversé du « H » de Hardwood. */
export function LogoMark({ size = 34 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
      <rect width="64" height="64" rx="15" fill="var(--c-accent)" />
      <circle cx="32" cy="32" r="21" fill="none" stroke="var(--c-accent-ink)" strokeWidth="3.2" />
      <path d="M11 32h42M17 17c8 8 8 22 0 30M47 17c-8 8-8 22 0 30" fill="none" stroke="var(--c-accent-ink)" strokeWidth="2.6" strokeLinecap="round" opacity="0.55" />
      <path d="M23 21v22M41 21v22M23 32h18" stroke="var(--c-accent-ink)" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export function Logo() {
  return (
    <Link to="/" className="group flex items-center gap-2.5" aria-label="Hardwood Atlas — accueil">
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span className="font-display text-[1.32rem] font-black uppercase tracking-[0.01em] text-ink">Hardwood</span>
        <span className="mt-0.5 font-mono text-[0.58rem] uppercase tracking-[0.42em] text-accent-text">Atlas · NBA</span>
      </span>
    </Link>
  );
}
